import { useNavigate, useParams } from "react-router";

import { Chip, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { ArcPlcBaseAcreIcon, InfoIcon, WarningIcon } from "components/Icons/Icons";
import { formatNumber, formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";

export default function ArcPlcProducerFarmCropCard({
  currentBaseAcres,
  currentArcPlc,
  isLoadingArcPlc,
  isErrorArcPlc,
}) {
  const navigate = useNavigate();
  const { crop_year, location_state_name, location_county_name, commodity_name, type_name } = useParams();

  return (
    <TilleyCard
      data-testid={currentBaseAcres?.id}
      onClick={() =>
        navigate(
          `/arcplc/${crop_year}/${location_state_name}/${location_county_name}/${commodity_name}/${type_name || "_"}/${currentBaseAcres?.id}`
        )
      }
      Avatar={ArcPlcBaseAcreIcon}
      title={currentBaseAcres?.farm_name}
      subtitle={"FSN " + currentBaseAcres?.fsa_farm_number}
      customContent={
        <Stack direction="column" spacing={2} className="custom-content">
          <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{formatNumber(currentBaseAcres?.base_acreage, 0)}</Typography>
              <Typography variant="overline">BASE ACRES</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">
                {formatNumber(currentBaseAcres?.plc_yield || currentBaseAcres?.plc_yield_weighted, 0)}
              </Typography>
              <Typography variant="overline">PLC YIELD</Typography>
            </Stack>
          </Stack>

          <Divider sx={{ margin: "0px !important" }} />

          {!isErrorArcPlc && (currentArcPlc?.arcPayment !== 0 || currentArcPlc?.plcPayment !== 0) && (
            <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
              <Stack direction="column" spacing={1}>
                <Typography variant="overline" className="payment-heading">
                  ARC-CO PAYMENT
                </Typography>
                <Typography variant="subtitle2">
                  {!isLoadingArcPlc && <>{formatPrice(currentArcPlc?.arcPayment, 2)}</>}
                  {isLoadingArcPlc && (
                    <>
                      <Skeleton />
                    </>
                  )}
                </Typography>
              </Stack>
              <Stack direction="column" spacing={1}>
                <Typography variant="overline" className="payment-heading">
                  PLC PAYMENT
                </Typography>
                <Typography variant="subtitle2">
                  {!isLoadingArcPlc && <>{formatPrice(currentArcPlc?.plcPayment, 2)}</>}
                  {isLoadingArcPlc && (
                    <>
                      <Skeleton />
                    </>
                  )}
                </Typography>
              </Stack>
            </Stack>
          )}

          {!isErrorArcPlc && currentArcPlc?.arcPayment === 0 && currentArcPlc?.plcPayment === 0 && (
            <Chip icon={<InfoIcon />} label="No payments projected" />
          )}

          {isErrorArcPlc && (
            <Chip className="warning" icon={<WarningIcon />} label="Unable to calculate ARC /PLC projections" />
          )}
        </Stack>
      }
      footer={""}
    />
  );
}
